import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Select2Data } from 'ng-select2-component';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { TalentService } from 'src/app/providers/talent/talent.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
declare let $: any;

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
})
export class JobsComponent implements OnInit {
  public empStatus = localStorage.getItem('emp_status');
  public empEntity = localStorage.getItem('entity');
  searchJobForm: FormGroup;
  public ijpList: any = [];
  // public ijp_filters = [];
  result: any;
  cityList: any = [];
  skillList: any = [];
  degsnList: any = [];
  ccList: Select2Data = [];
  stateList: any = [];
  dynamicHeader: any;
  empSkillForm: FormGroup;
  loading: boolean;
  submitted: boolean;
  skilList: any;
  public currentType: any;
  // tslint:disable-next-line: variable-name
  emId: any;
  docsFile: any = [];
  empJobsForm: FormGroup;
  jobList: any;
  degsnOrgList: Select2Data = [];
  cityOrgList: Select2Data = [];
  regionList: any;
  public cnID: any;
  public resultR: any;
  public cateList: any;
  public type: any = [];
  ijpList1: any = [];
  appStatus: any;
  ijpList2: any = [];
  response: any = [];
  regionAll: any = [];
  ipAddress: any;
  ijpListReular: any = [];
  public page = 1;
  public pageF = 1;
  public count = 0;
  public countF = 0;
  public pageSize = 50;
  public pageSizeF = 50;
  public from;
  public fromF;
  public to;
  public toF;
  ijpListReularCount: any;
  ijpListCount: any;
  ijpListFTC: any;
  // public countS = 0;
  // public fromS;
  // public toS;
  tabs = {
    a: true,
    b: false,
  };
  activeTabR: any;
  activeTabF: any;
  desginData: any;

  constructor(
    private talentService: TalentService,
    private router: Router,
    private genService: GeneralService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private notifyService: NotificationService,
    private location: Location
  ) {
    console.log('jobs ye', document.referrer);
  }

  ngOnInit(): void {
    if (this.empEntity == '2') {
      this.activeTabF = true;
      this.tabs.b = false;
      this.tabs.a = true;
      this.activeTabR = false;
      this.searchJobsFTC('');
    } else if (this.empStatus == null) {
      this.tabs.a = true;
      this.tabs.b = false;
      this.activeTabF = true;
      this.activeTabR = false;
    } else {
      this.tabs.b = false;
      this.tabs.a = true;
      this.activeTabR = true;
      this.activeTabF = false;
      // this.searchJobsFTC('');
    }
    // if (this.empEntity != '2') {
    //   this.tabs.a = true;
    //   this.tabs.b = false;
    //   this.searchJobsRegular('');
    // } else if (this.empStatus == '' || this.empStatus == 'ex') {
    //   this.tabs.a = false;
    //   this.tabs.b = true;
    //    this.searchJobsFTC('');
    // }
    console.log(this.empStatus);
    // this.getIjpMrfs();
    this.searchJobForm = new FormGroup({
      cost_center: new FormControl(),
      skill_type: new FormControl(),
      region: new FormControl(),
      design: new FormControl(),
      state: new FormControl(),
      city: new FormControl(),
      // date_from : new FormControl(),
      // date_to : new FormControl()
    });
    this.searchJobs();
    this.getJobsFilter();
    this.getStateFilter();
    this.getRegion();
    // this.getDesignation();
  }

  changeEvent(id) {
    this.tabs[id] = true;
    if (id == 'a') {
      this.tabs = {
        a: true,
        b: false,
      };
      this.searchJobsFTC('');
    }
    if (id == 'b') {
      this.tabs = {
        a: false,
        b: true,
      };
      this.searchJobsRegular('');
    }
  }

  getNumberPerPage(event): void {
    this.pageSize = event.target.value;
    this.searchJobsRegular('');
  }
  handlePageChange(event): void {
    this.page = event;
    this.searchJobsRegular('');
  }
  getNumberPerPageF(event): void {
    this.pageSizeF = event.target.value;
    this.searchJobsFTC('');
  }
  handlePageChangeF(event): void {
    this.pageF = event;
    this.searchJobsFTC('');
  }

  searchJobs(): void {
    this.page = 1;
    this.pageSize = 50;
    this.pageF = 1;
    this.pageSizeF = 50;
    console.log(this.tabs);
    if (this.tabs.a) {
      this.searchJobsFTC(this.searchJobForm.value);
    }
    if (this.tabs.b) {
      this.searchJobsRegular(this.searchJobForm.value);
    }
  }

  searchJobsRegular(data): void {
    console.log(data);
    // return;
    this.authService
      .getIjpMrfsRegular({
        forms: data,
        pageIndex: this.page,
        limit: this.pageSize,
      })
      .subscribe(
        (res) => {
          this.result = res;
          console.log(this.ijpList1);
          this.ijpListReular = this.result.data2.data;
          this.ijpListReularCount = this.result.count;
          this.count = this.result.data2.total;
          this.from = this.result.data2.from;
          this.to = this.result.data2.to;
          // this.cateList = this.ijpList1.emp_cate;
          // console.log(this.cateList);
        },
        (err) => {}
      );
  }
  searchJobsFTC(data): void {
    console.log(data);
    // return;
    this.authService
      .getIjpMrfsFTC({
        forms: data,
        pageIndex: this.pageF,
        limit: this.pageSizeF,
      })
      .subscribe(
        (res) => {
          this.result = res;
          this.ijpListFTC = this.result.data.data;
          this.ijpListCount = this.result.count;
          this.countF = this.result.data.total;
          this.fromF = this.result.data.from;
          this.toF = this.result.data.to;
          // this.cateList = this.ijpList1.emp_cate;
          // console.log(this.cateList);
        },
        (err) => {}
      );
  }
  getRegion(): void {
    this.authService.getAllRegion().subscribe((res) => {
      this.response = res;
      this.regionAll = this.response.data;
    });
  }
  getStateFilter(): void {
    this.authService.getStateForFilter().subscribe((res) => {
      this.result = res;
      this.stateList = this.result.data;
      // this.result.data.forEach(element => {
      //   this.stateList.push({ label: element.st_name, value: element.st_id});
      // });
    });
  }
  getCity(stId): void {
    this.authService.getCityForFilter(stId).subscribe((res) => {
      this.result = res;
      this.cityList = this.result.data;
      // this.result.data.forEach(elct => {
      //   this.cityList.push({label: elct.ct_name, value: elct.ct_id });
      // });
    });
  }
  getStateCity(event): void {
    let stId;
    stId = event.target.value;
    if (stId === '' || stId == null) {
    } else {
      this.getCity(stId);
    }
  }
  getJobsFilter(): void {
    this.authService.getInternalJobsFilter().subscribe((res) => {
      this.result = res;
      this.skillList = this.result.data.skill_types;
      // this.result.data.skill_types.forEach(element => {
      //   this.skillList.push({ label: element.label, value: element.value});
      // });
      this.degsnList = this.result.data.designation;
      // .forEach(eld => {
      //   this.degsnList.push({ label: eld.label, value: eld.value});
      // });
      // this.result.data.cost_centers.forEach( elc => {
      //   this.ccList.push({ label: elc.label , value: elc.value});
      // });
    });
  }
  resetIJPFilter(): void {
    this.searchJobForm.reset();
    this.searchJobs();
  }
  checkBugetfrom(num): boolean {
    if (this.isFloat(num) == true || this.isInt(num) == true) {
      return true;
    }
    return false;
  }
  isInt(n): boolean {
    return Number(n) === n && n % 1 === 0;
  }

  isFloat(n): boolean {
    return Number(n) === n && n % 1 !== 0;
  }

  logout(): void {
    const params = {
      ip: this.ipAddress,
      source: 'web',
    };
    console.log('pp', params);
    const popUp = localStorage.getItem('popUp');
    const date = localStorage.getItem('date');
    const usrId = localStorage.getItem('usrId');
    const ballon = localStorage.getItem('showBallon');
    const evntDate = localStorage.getItem('eventDate');

    this.authService.logOutFromJobs(params).subscribe(
      (res) => {
        this.result = res;
        // if (this.result.status) {
        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        this.router.navigate(['/']);
        this.notifyService.showSuccess(this.result.msg, 'Success');
        // }
      },
      (err) => {
        localStorage.clear();
        localStorage.setItem('popUp', popUp);
        localStorage.setItem('date', date);
        localStorage.setItem('usrId', usrId);
        localStorage.setItem('showBallon', ballon);
        localStorage.setItem('eventDate', evntDate);

        this.router.navigate(['/']);
        this.notifyService.showSuccess(this.result.msg, 'Success');
      }
    );
  }

  queryModal(): void {
    this.router.navigate(['/alumni-queries']);
    // $('#show_quer_modal').modal({ backdrop: 'static' , keyboard: false});
  }

  // getDesignation(): void {
  //   this.authService.getDesignation().subscribe( res => {
  //     this.result = res;
  //     this.desginData = this.result.data;
  //   });
  // }
}
